import {
  Button,
  Layout,
  Image,
  Form,
  Input, Spin,
  Select,
  DatePicker,
  Empty, Dropdown, InputNumber,
  Table, Modal, Menu,
  Row, Col, Carousel, FloatButton, Pagination, Skeleton, Space, Divider, Tag,Breadcrumb,Collapse,Drawer
} from "ant-design-vue";

export const antArr = [
  Button, Dropdown,
  Layout,
  Image, Form,
  Select, Menu,
  Input, Modal, InputNumber,
  Spin, Empty,
  DatePicker,
  Table, Tag,
  Row, Col, Carousel, FloatButton, Pagination, Skeleton, Space, Divider,Breadcrumb,Collapse,Drawer

];
